@let isSystemRunning = isSystemRunning$ | async;

@if (type === "dashboard") {
  <app-card
    class="system-stop button primary-button card-button"
    [class.danger]="isSystemRunning"
    [matTooltip]="
      (isSystemRunning
        ? 'dashboard.systemStop.stop.description'
        : 'dashboard.systemStop.start.description'
      ) | translate
    "
    (click)="onToggleSystem(isSystemRunning)"
  >
    @if (isSystemRunning) {
      <app-icon name="ic_pause_filled" />
    } @else {
      <app-icon name="ic_play_filled" />
    }
    <div>
      @if (isSystemRunning) {
        <h3 class="uppercase line-clamp">
          {{ "dashboard.systemStop.stop.headline" | translate }}
        </h3>
        <p class="line-clamp">
          {{ "dashboard.systemStop.stop.subheadline" | translate }}
        </p>
      } @else {
        <h3 class="uppercase line-clamp">
          {{ "dashboard.systemStop.start.subheadline" | translate }}
        </h3>
        <p class="line-clamp">
          {{ "dashboard.systemStop.start.headline" | translate }}
        </p>
      }
    </div>
  </app-card>
} @else {
  @let isEmegancyStopActive = isEmegancyStopActive$ | async;
  @if (isSystemRunning === false) {
    <app-card
      class="system-stop stop"
      [class.emergency-stop]="isEmegancyStopActive"
    >
      <div class="header">
        <div>
          @if (isEmegancyStopActive) {
            <h3>
              {{ "dashboard.systemStop.emergancyStop.headline" | translate }}
            </h3>
            <p>
              {{ "dashboard.systemStop.emergancyStop.description" | translate }}
            </p>
          } @else {
            <h3>{{ "dashboard.systemStop.start.headline" | translate }}</h3>
            <p>{{ "dashboard.systemStop.start.description" | translate }}</p>
          }
        </div>
        @if (!isEmegancyStopActive) {
          <button
            type="button"
            class="button primary-button icon-button column"
            (click)="onStartSystem()"
          >
            <app-icon name="ic_play" />
            {{ "dashboard.systemStop.start.label" | translate }}
          </button>
        }
      </div>
    </app-card>
  }
}
